
define('template!vectorDatePickerPopoverTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="panel panel-default shadow-0 m-b-0">\n  <div class="panel-body row p-b-0">\n    <div class="row">\n      <div class="form-group col-md-12 date-picker-holder">\n        <input type="text" class="js-date-from form-control floating-label" placeholder="' +
((__t = ( _.i18n('common.fromDate') )) == null ? '' : __t) +
'"/>\n      </div>\n    </div>\n    <div class="row">\n      <div class="form-group col-md-12 date-picker-holder">\n        <input type="text" class="js-date-to form-control floating-label" placeholder="' +
((__t = ( _.i18n('common.toDate') )) == null ? '' : __t) +
'"/>\n      </div>\n    </div>\n    <div class="row">\n      <button class="btn btn-primary btn-xs f-r m-r-10 js-apply">' +
((__t = ( _.i18n('common.apply') )) == null ? '' : __t) +
'</button>\n    </div>\n  </div>\n</div>';

}
return __p
};});

